import React, { useCallback, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Container,Jumbotron } from 'react-bootstrap';
import ParticipantCompiler from './components/compiler/ParticipantCompiler'
const SolveQuestion = ({location}) =>{
    const [questionId, setQuestionId] = useState([])
    const [questionData, setQuestionsData] = useState({})
    const [testCasesData, setTestCasesData] = useState({})
    const [state, setState] = useState({
        "rows": 5,
		"minRows": 5,
		"maxRows": 10,
    })

    
    const [loader, setLoader] = useState(true)


    const handleChange = (event) => {
		const textareaLineHeight = 24;
		const { minRows, maxRows } = state;
		
		const previousRows = event.target.rows;
  	event.target.rows = minRows; // reset number of rows in textarea 
		
		const currentRows = ~~(event.target.scrollHeight / textareaLineHeight);
    
    if (currentRows === previousRows) {
    	event.target.rows = currentRows;
    }
		
		if (currentRows >= maxRows) {
			event.target.rows = maxRows;
			event.target.scrollTop = event.target.scrollHeight;
		}
    
  	setState({
    	value: event.target.value,
      rows: currentRows < maxRows ? currentRows : maxRows,
    });
    };
    
    const loadData = useCallback(async() =>{
        setLoader(true)
        const params = new URLSearchParams(location.search)
        const temp2 = params.get("UQI")
        const tempArr = temp2.split("@")
        setQuestionId(tempArr)
        const response = await fetch(`https://codezap-e156b.firebaseio.com/contests/${tempArr[1]}/questions/${tempArr[0]}.json`)
        const resData = await response.json()
        if(resData){
            setQuestionsData(resData)
            if(resData["testCases"]){
                setTestCasesData(resData["testCases"])
            }
        }
        setLoader(false)
    },[location.search])

    useEffect(() =>{
        loadData()
    },[loadData])


    
    return (
        <section className = "hero">
            <header className="mb-4 shadow">
                <nav className="navbar navbar-dark bg-dark primary-styled-border">
                    <div className="container">
                        
                        <Link to = {"/contest?UCI="+questionId[1]} style = {{color:"white"}}>
                            <i className="fa fa-arrow-left" aria-hidden="true" style = {{fontSize:"40px"}}></i>
                        </Link>
                        <div>
                        
                        
                        {loader ? <p></p>:<h1 style = {{color:"white"}}> {questionId[0].split("_").join(" ").substring(0, questionId[0].split("_").join(" ").length - 4)}</h1>}
                        </div>
                    </div>
                </nav>
            </header> 
            <Container style = {{marginTop:"2%"}}>
            {loader ? <h1>Loading...</h1> :
                <>
                <h3 style = {{fontWeight:"bold"}}>Description</h3>
                <hr />
                <textarea 
                    className='autoExpand textarea1' 
                    rows="8"
                    
                    readOnly
                    style = {{
                        width:"100%",
                        backgroundColor:"#fff",
                        boxSizing: "border-box  !important",
                        border: "none !important",
                        borderRadius:" 3px !important",
                        resize: "none !important",
                        fontSize: "20px !important",
                        lineHeight: "24px !important",
                        overflow: "auto !important",
                        height: "auto !important",
                        padding: "8px !important",
                        
                        }}
                    value = {questionData.description}
                    onChange={handleChange}
                />
                
                 <br/>
                <h3 style = {{fontWeight:"bold"}}>Constraints</h3>
                <hr />
                <textarea 
                    className='autoExpand textarea1' 
                    rows="4"
                    
                    readOnly
                    style = {{
                        width:"100%",
                        backgroundColor:"#fff",
                        boxSizing: "border-box  !important",
                        border: "none !important",
                        borderRadius:" 3px !important",
                        resize: "none !important",
                        fontSize: "20px !important",
                        lineHeight: "24px !important",
                        overflow: "auto !important",
                        height: "auto !important",
                        padding: "8px !important",
                        
                        }}
                    value = {questionData.constraints}
                    onChange={handleChange}
                />
                
                <br />
                <br />
                <h3 style = {{fontWeight:"bold"}}>Input Format</h3>
                <hr />
                <textarea 
                    className='autoExpand textarea1' 
                    rows="4"
                    
                    readOnly
                    style = {{
                        width:"100%",
                        backgroundColor:"#fff",
                        boxSizing: "border-box  !important",
                        border: "none !important",
                        borderRadius:" 3px !important",
                        resize: "none !important",
                        fontSize: "20px !important",
                        lineHeight: "24px !important",
                        overflow: "auto !important",
                        height: "auto !important",
                        padding: "8px !important",
                        
                        }}
                    value = {questionData.inputFormat}
                    onChange={handleChange}
                />
                
                <br/>
                <h3 style = {{fontWeight:"bold"}}>Output Format</h3>
                <hr />
                <textarea 
                    className='autoExpand textarea1' 
                    rows="4"
                    
                    readOnly
                    style = {{
                        width:"100%",
                        backgroundColor:"#fff",
                        boxSizing: "border-box  !important",
                        border: "none !important",
                        borderRadius:" 3px !important",
                        resize: "none !important",
                        fontSize: "20px !important",
                        lineHeight: "24px !important",
                        overflow: "auto !important",
                        height: "auto !important",
                        padding: "8px !important",
                        
                        }}
                    value = {questionData.outputFormat}
                    onChange={handleChange}
                />
                
                <br />
                <br />
                <h3 style = {{fontWeight:"bold"}}>Examples</h3>
                <hr />
                <h4 style = {{fontWeight:"bold"}}>Example 1</h4>
                <br />
                <Jumbotron>
                <textarea 
                    className='autoExpand textarea1' 
                    rows="8"
                    
                    readOnly
                    style = {{
                        width:"100%",
                        backgroundColor:"#e9ecef",
                        boxSizing: "border-box  !important",
                        border: "none !important",
                        borderRadius:" 3px !important",
                        resize: "none !important",
                        fontSize: "20px !important",
                        lineHeight: "24px !important",
                        overflow: "auto !important",
                        height: "auto !important",
                        padding: "8px !important",
                        
                        }}
                    value = {questionData.example1}
                    onChange={handleChange}
                />
                    
                </Jumbotron>
                <br/>

                <h4 style = {{fontWeight:"bold"}}>Example 2</h4>
                <br />
                <Jumbotron>
                <textarea 
                className='autoExpand textarea1' 
                rows="8"
                
                readOnly
                style = {{
                    width:"100%",
                    backgroundColor:"#e9ecef",
                    boxSizing: "border-box  !important",
                    border: "none !important",
                    borderRadius:" 3px !important",
                    resize: "none !important",
                    fontSize: "20px !important",
                    lineHeight: "24px !important",
                    overflow: "auto !important",
                    height: "auto !important",
                    padding: "8px !important",
                    
                    }}
                value = {questionData.example2}
                onChange={handleChange}
            />
                
                </Jumbotron>

                
                <br />
                <ParticipantCompiler 
                    data = {questionData} testCasesData = {testCasesData} UCQI = {questionId}/>
             </>   
            }         
            </Container>
           
        </section>
    )
}

export default SolveQuestion;